export const isMobileApp = () => {
  if (localStorage.appDevice) {
    const device = localStorage.appDevice;
    if (device === 'ios' || device === 'android') {
      return true;
    }
  }
};
